'use client'

import { getCookie } from 'shared/libs/storage/cookie'

import { Image } from 'shared/ui'
import { Button } from 'shared/ui/button'

import { commonApi } from 'shared/config/axios/commonApi'
import { globalStyles } from 'shared/config/styles/globalStyles'

// Error boundaries must be Client Components
import styles from './globalError.module.scss'

interface GlobalErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function GlobalError({}: GlobalErrorProps) {
  const isWebview = getCookie('isWebview') === 'true'

  const handleLogout = async () => {
    try {
      await commonApi.closeWebview()
    } catch (error) {}
  }

  return (
    <html>
      <body className={styles.body} style={globalStyles}>
        <div className={styles.errorWrapper}>
          <Image
            className={styles.logo}
            src={'/static/svg/market-logo.svg'}
            width={180}
            height={40}
            alt="market-logo"
          />
          <div className={styles.content}>
            <Image
              className={styles.img}
              src={'/static/png/global-error.png'}
              width={280}
              height={360}
              alt={''}
            />
            <div className={styles.textWrapper}>
              <h2 className={styles.title}>Технические неполадки</h2>
              <p className={styles.text}>
                Это временно, работаем над восстановлением.
              </p>
            </div>
            {isWebview && (
              <Button onClick={handleLogout}>Вернуться позже</Button>
            )}
          </div>
        </div>
      </body>
    </html>
  )
}
